import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/new_ui/Modal/Modal';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Items from './Popup/Items';
import Stripe from './Popup/Stripe';

import Actions from './Actions';

export default function BuyModal({
  wallet, plan, closeModal, setWaitPayment,
}) {
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    Actions.preparePayment(plan.sessions, (data) => {
      setClientSecret(data.client_secret);
    }, () => {
      // TODO: error case
    });
  }, [plan]);

  return (
    <Modal onHide={closeModal} header={<h3>Summary</h3>} show>
      <div className="wallet-summary">
        {clientSecret === null && <LoadingPlaceholder text="Loading..." />}
        {clientSecret !== null && (
          <>
            <Items plan={plan} wallet={wallet} />
            <Stripe clientSecret={clientSecret} closeModal={closeModal} setWaitPayment={setWaitPayment} />
          </>
        )}
      </div>

    </Modal>
  );
}

BuyModal.propTypes = {
  wallet: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  setWaitPayment: PropTypes.func.isRequired,
};
